import * as React from "react";

import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBDatePickerOptions} from "./FBDatePicker.options";
import {DateUtilities} from "FormBuilder/Utilities/DateUtilities";


let format=require('date-fns/format').default;
export class FBDatePickerModel extends FBFieldWithPriceBaseModel<FBDatePickerOptions,FBColumnModel>
{
    public Date:number;
    public DateFormat:string;
    public IsFocused:boolean;

    constructor(Options: FBDatePickerOptions, Parent: FBColumnModel) {
        super(Options, Parent);
        this.IsFocused=false;
    }

    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.Unix=this.GetValue();

        let date=new Date(obj.Unix*1000);
        date=new Date(date.setMinutes(date.getMinutes()+date.getTimezoneOffset()));
        obj.Value=format(date,this.DateFormat);
    }



    GetStoresInformation(): boolean {
        return true;
    }

    GetIsUsed()
    {
        if(!super.GetIsUsed())
            return false;
        return this.GetValue()>0;
    }

    GetValue() {
        if(!this.GetIsVisible())
            return 0;
        return this.Date;
    }

    CalculateDefaultDate(){
        this.Date=0;
        let dateToUse:Date=null;
        if(this.Options.DefaultDate.indexOf('/')>=0)
        {
            let dateParts=this.Options.DefaultDate.split('/');
            if(dateParts.length==3)
            {
                let year=parseInt(dateParts[0]);
                let month=parseInt(dateParts[1]);
                let day=parseInt(dateParts[2]);
                if(!isNaN(year)&&!isNaN(month)&&!isNaN(day))
                {
                    month--;
                    dateToUse=new Date(year,month,day);
                }
            }
        }else{
            if(this.Options.DefaultDate.trim()!='')
            {
                let numberOfDays=parseFloat(this.Options.DefaultDate.trim());
                dateToUse=new Date();
                dateToUse.setHours(0);
                dateToUse.setMinutes(0);
                dateToUse.setMilliseconds(0);
                dateToUse.setDate(dateToUse.getDate()+numberOfDays);
            }
        }


        if(dateToUse!=null)
        {
            this.Date=DateUtilities.DateToUnix(dateToUse);
        }






    }

    public CalculateDateFormat() {
        if(this.Options.EnableTimePicker)
            this.DateFormat='MM/dd/yyyy h:mm';
        else
            this.DateFormat='MM/dd/yyyy';
        try{
            format(new Date(),this.Options.Format+(this.Options.EnableTimePicker?' '+this.Options.TimeFormat:''));
        }catch(e )
        {
            return;
        }

        this.DateFormat=this.Options.Format+(this.Options.EnableTimePicker?' '+this.Options.TimeFormat:'');
    }

    InitializeStartingValues() {
        this.Date=0;
        this.CalculateDefaultDate();
        this.DateFormat='';
        this.Date=this.GetPreviousDataProperty('Unix', this.Date);
        this.Quantity=this.GetPreviousDataProperty( 'Quantity',this.Options.QuantityDefaultValue==''?"": this.ParseNumber(this.Options.QuantityDefaultValue));
        this.CalculateDateFormat();
    }


    GetDynamicFieldNames(): string[] {
        return ['FBDatePicker'];
    }
}